/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `JobExecutionStatus*`'s.
 */
export type JobExecutionStatus =
  | JobExecutionStatusQueued
  | JobExecutionStatusTerminated
  | JobExecutionStatusSuccess
  | JobExecutionStatusRunning
  | JobExecutionStatusErrored;

/**
 * The job execution status queued type.
 */
type JobExecutionStatusQueued = typeof JOB_EXECUTION_STATUS_QUEUED;
/**
 * The job execution status terminated type.
 */
type JobExecutionStatusTerminated = typeof JOB_EXECUTION_STATUS_TERMINATED;
/**
 * The job execution status success type.
 */
type JobExecutionStatusSuccess = typeof JOB_EXECUTION_STATUS_SUCCESS;
/**
 * The job execution status running type.
 */
type JobExecutionStatusRunning = typeof JOB_EXECUTION_STATUS_RUNNING;
/**
 * The job execution status errored type.
 */
type JobExecutionStatusErrored = typeof JOB_EXECUTION_STATUS_ERRORED;

/**
 * The job execution status queued constant.
 */
export const JOB_EXECUTION_STATUS_QUEUED = 'queued';

/**
 * The job execution status terminated constant.
 */
export const JOB_EXECUTION_STATUS_TERMINATED = 'terminated';

/**
 * The job execution status success constant.
 */
export const JOB_EXECUTION_STATUS_SUCCESS = 'successfully-completed';

/**
 * The job execution status running constant.
 */
export const JOB_EXECUTION_STATUS_RUNNING = 'running';

/**
 * The job execution status errored constant.
 */
export const JOB_EXECUTION_STATUS_ERRORED = 'errored';
